import React, { useCallback, useContext } from 'react'
import Subscriptions from './Subscriptions'
import * as actions from '../store/actions'
import { AppContext } from '../../../global'
import { useParams } from 'react-router-dom'
import { Params } from '../../types'

function SubscriptionsRoute() {
  const { state, execute } = useContext(AppContext)
  const { partnerId } = useParams() as Params

  const loadSubscriptions = useCallback(async function (page: number, partnerId: string, sort: string) {
    await execute(actions.loadSubscriptions(page, partnerId, sort))
  }, [execute])

  const loadFilteredSubscriptions = useCallback(async function (filter: string, page: number, partnerId: string, sort: string) {
    await execute(actions.loadFilteredSubscriptions(filter, page, partnerId, sort))
  }, [execute])

  const loadSubscriptionDetails = useCallback(async function (subscriptionId: string) {
    await execute(actions.loadSubscriptionDetails(subscriptionId))
  }, [execute])

  const setFilterPanelOpen = useCallback(function (open: boolean) {
    execute(actions.setFilterPanelOpen(open))
  }, [execute])

  const loadFilters = useCallback(async function (partnerId: string) {
    await execute(actions.loadFilters(partnerId))
  }, [execute])

  const loadSingleSubscription = useCallback(async function (subscriptionId: string) {
    await execute(actions.loadSingleSubscription(subscriptionId))
  }, [execute])

  const loadAccountSubscription = useCallback(async function (accountId: string) {
    await execute(actions.loadAccountSubscription(accountId))
  }, [execute])

  const setSubscriptionExpanded = useCallback(async function (subscriptionId: string, expanded: boolean) {
    await execute(actions.setSubscriptionExpanded(subscriptionId, expanded))
  }, [execute])

  const searchSubscriptions = useCallback(async function(partnerId: string, text: string, includeDeactivated: boolean, page: number, sort: string) {
    await execute(actions.searchSubscriptions(partnerId, text, includeDeactivated, page, sort))
  }, [execute])

  const loadSubscriptionAccountFilters = useCallback(async function(subscriptionId: string, accountId: string) {
    await execute(actions.loadSubscriptionAccountFilters(subscriptionId, accountId))
  }, [execute])

  return (
    <Subscriptions
      state={state.subscriptions}
      filters={state.filters}
      partnerId={partnerId}
      loadFilters={loadFilters}
      loadSubscriptions={loadSubscriptions}
      loadFilteredSubscriptions={loadFilteredSubscriptions}
      loadSubscriptionDetails={loadSubscriptionDetails}
      setFilterPanelOpen={setFilterPanelOpen}
      loadSingleSubscription={loadSingleSubscription}
      setSubscriptionExpanded={setSubscriptionExpanded}
      loadAccountSubscription={loadAccountSubscription}
      searchSubscriptions={searchSubscriptions}
      loadSubscriptionAccountFilters={loadSubscriptionAccountFilters}
    />
  )
}

export default SubscriptionsRoute
